import { JOB_SEARCH_EVENTS } from '../../constants/events';


const defaultContext = {
  page: 1,
  jobs: [],
  idList: [],
  dfpOptions: []
};

/**
 * Default context values for jobs. Can include city, role, packs
 */
const defaultContextNew = defaultContext;

const jobSearchReducer = (state = defaultContextNew, actions) => {
  switch (actions.type) {
    case JOB_SEARCH_EVENTS.UPDATE_JOB_SEARCH_LIST:
      if (actions.payload.replaceJobs) {
      } else {
        actions.payload.jobs = state.jobs.concat( actions.payload.jobs);
      }

      state = Object.assign({}, state, actions.payload);
      break;
    case JOB_SEARCH_EVENTS.UPDATE_DFP_OPTIONS:
      state = Object.assign({}, state, actions.payload);
      break;
    case JOB_SEARCH_EVENTS.EMPTY_JOB_SEARCH_LIST:
      actions.payload.jobs = [];
      state = Object.assign({}, defaultContext, { dfpOptions: state.dfpOptions, flyingCarpetPosition: state.flyingCarpetPosition });
      break;
    case JOB_SEARCH_EVENTS.TOGGLE_JOB_LIST_DISPLAY:
      state = Object.assign({}, state, actions.payload);
      break;
    case JOB_SEARCH_EVENTS.UPDATE_JOB_SEARCH_REDUCER:
      if (!actions.payload.replaceJobs) {
        actions.payload.jobs = state.jobs.concat( actions.payload.jobs);
      }
      state = Object.assign({}, state, actions.payload);
      break;
  }

  return state;
};

export default jobSearchReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/JobSearchReducer/index.js